import classnames from "classnames";
import * as React from 'react';

export const ErrorMessage: React.FC<Props> = (props) => {
    return (
    <div className = {classnames("error-message", {"no-margin": props.noMargin})}>
        <i className='fa-Light fa-Exclamation-Triangle' />
        <div>
            <label>{props.title}</label>
            <div>
                {props.message}
            </div>
        </div>

    </div>
    )
}

interface Props {
    title?: string;
    message?: string;
    noMargin?: boolean;
}

ErrorMessage.defaultProps = {
    title: "Error",
    message: "An unexpected error occurred."
}